<!-- Table -->
<table mat-table matSort
  class="table-container"
  [dataSource]="dataSource"
  (matSortChange)="onSort($event)">

  <!-- Secondary Header -->
  @if (hasHeader) {
    @for (head of headerColumns; track head) {
      <ng-container [matColumnDef]="head.label">
        <th scope="col" class="bg-orange mat-header-cell" mat-header-cell *matHeaderCellDef  [attr.colspan]="head.span">
          {{head.label}}
        </th>
      </ng-container>
    }
  }

  <!-- Actions -->
  @if (hasEdit || hasDelete) {
    <ng-container matColumnDef="actions">
      <th mat-header-cell class="mat-header-cell" *matHeaderCellDef>actions</th>
      <td mat-cell class="mat-cell" *matCellDef="let lineItem">
        <div>
          @if (hasEdit) {
            <button (click)="onEdit(lineItem.id)"><mat-icon>edit</mat-icon></button>
          }
          @if (hasDelete) {
            <button (click)="onDelete(lineItem.id)"><mat-icon>delete</mat-icon></button>
          }
        </div>
      </td>
    </ng-container>
  }

  <!-- Data -->
  @for (colDef of displayedColumns; track colDef) {
    <ng-container [sticky]="colDef.sticky ?? false" matColumnDef="{{colDef.label}}">
      <th mat-header-cell class="mat-header-cell" mat-sort-header sortActionDescription="sort by {{colDef.label}}" *matHeaderCellDef>{{colDef.label}}</th>
      <td mat-cell class="mat-cell"  *matCellDef="let lineItem">
        {{ lineItem[colDef.key] }}
      </td>
      @if (hasTotal) {
        <td mat-footer-cell class="mat-cell" *matFooterCellDef>{{ total[colDef.key] }}</td>
      }
    </ng-container>
  }

  <!-- Header Row -->
  @if (hasHeader) {
    <tr mat-header-row class="mat-row" *matHeaderRowDef="headerTitles; sticky: true"></tr>
  }

  <!-- Data Rows -->
  <tr mat-header-row class="mat-row" *matHeaderRowDef="columnTitles; sticky: true"></tr>
  <tr mat-row class="mat-row tracker-data-row" (click)="onClick(row)" *matRowDef="let row; columns: columnTitles"></tr>

  <!-- Footer Row -->
  @if (hasTotal) {
    <tr mat-footer-row class="mat-row" *matFooterRowDef="columnTitles"></tr>
  }
</table>